import client from './main-client';

export const fetchConfAgreementApi = (params) => client().get(`/conf-agreement/${params.id}`);
